const NotFound = () => {
    return <h1>NotFOUND</h1>;
}

export default NotFound;